import { render, staticRenderFns } from "./ChargeExplain.vue?vue&type=template&id=2ac30df0&"
import script from "./ChargeExplain.vue?vue&type=script&lang=js&"
export * from "./ChargeExplain.vue?vue&type=script&lang=js&"
import style0 from "./ChargeExplain.vue?vue&type=style&index=0&id=2ac30df0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports